"use client"
import React, { useEffect } from 'react'

const LoaderScripts = () => {
    useEffect(() => {
        // Use native DOM API instead of jQuery for better performance
        const preloader = document.getElementById('preloader');
        if (preloader) {
            // Fade out preloader using CSS transitions (no jQuery dependency needed)
            preloader.style.transition = 'opacity 0.5s ease-in-out';
            setTimeout(() => {
                preloader.style.opacity = '0';
                setTimeout(() => {
                    preloader.style.display = 'none';
                }, 500);
            }, 300);
        }
    }, []);

    return null
}

export default LoaderScripts
